module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand2-b07d8ff35249d527d1fd51a6db888c94.jpg";